'use strict';

var isInteger = require('is-integer');

var isIntegerRegex = /^-?\d+$/;

module.exports = function parseIntStrict(integer) {
  if (typeof integer === 'number') {
    return isInteger(integer) ? integer : undefined;
  }

  if (typeof integer === 'string') {
    return isIntegerRegex.test(integer) ? parseInt(integer, 10) : undefined;
  }
};